module.exports = __webpack_public_path__ + "static/media/phone.f94b465c.svg";